import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import './VideoModal.css'

interface VideoModalProps {
  videoUrl: string
  // ДЦ отключил звук: глушим и не даём включить через контролы плеера
  muted?: boolean
  isOpen: boolean
  onClose: () => void
}

export default function VideoModal({ videoUrl, muted = false, isOpen, onClose }: VideoModalProps) {
  const { t } = useTranslation()
  useEffect(() => {
    // Закрытие по Escape
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      // Блокируем скролл body при открытом модальном окне
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'unset'
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  // Формируем полный URL для видео
  // Если URL относительный, преобразуем путь /videos/filename.mp4 в /downloadFile/filename.mp4
  let fullVideoUrl: string
  if (videoUrl.startsWith('http')) {
    fullVideoUrl = videoUrl
  } else {
    // Извлекаем имя файла из пути (например, /videos/4527742.mp4 -> 4527742.mp4)
    const fileName = videoUrl.split('/').pop() || videoUrl
    // Формируем полный URL с /downloadFile/
    const apiHost = import.meta.env.VITE_API_HOST ?? 'https://api.verrafied.ai'
    fullVideoUrl = `${apiHost}/downloadFile/${fileName}`
  }

  return (
    <div className="video-modal" onClick={onClose}>
      <div className="video-modal__content" onClick={(e) => e.stopPropagation()}>
        <button 
          className="video-modal__close"
          onClick={onClose}
          aria-label={t('video_modal.close')}
        >
          ×
        </button>
        <video 
          className={`video-modal__player${muted ? ' video-modal__player--muted' : ''}`}
          src={fullVideoUrl}
          controls
          autoPlay
          muted={muted}
          onVolumeChange={muted ? (e) => {
            const v = e.currentTarget
            if (!v.muted || v.volume > 0) {
              v.muted = true
              v.volume = 0
            }
          } : undefined}
        >
          {t('video_modal.no_support')}
        </video>
      </div>
    </div>
  )
}
